const STORAGE_KEY = "dm_conteudos_modulo";
const STORAGE_VERSION = "v2";
const EMPTY_CONTEUDOS_DATA = {
  categorias: [],
  cursos: [],
  modulos: [],
  aulas: [],
  erros: [],
  progresso: {},
};
const clone = (value) => JSON.parse(JSON.stringify(value));
export function createDefaultConteudosData() {
  return clone(EMPTY_CONTEUDOS_DATA);
}
export const normalizeConteudosData = (value) => {
  const fallback = createDefaultConteudosData();
  if (!value || typeof value !== "object") {
    return fallback;
  }
  return {
    categorias: Array.isArray(value.categorias)
      ? value.categorias
      : fallback.categorias,
    cursos: Array.isArray(value.cursos) ? value.cursos : fallback.cursos,
    modulos: Array.isArray(value.modulos) ? value.modulos : fallback.modulos,
    aulas: Array.isArray(value.aulas) ? value.aulas : fallback.aulas,
    erros: Array.isArray(value.erros) ? value.erros : [],
    progresso:
      value.progresso &&
      typeof value.progresso === "object" &&
      !Array.isArray(value.progresso)
        ? value.progresso
        : {},
  };
};
export function loadConteudosData() {
  if (typeof window === "undefined") {
    return createDefaultConteudosData();
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const version = window.localStorage.getItem(`${STORAGE_KEY}_version`);
    if (!raw || version !== STORAGE_VERSION) {
      return createDefaultConteudosData();
    }
    return normalizeConteudosData(JSON.parse(raw));
  } catch {
    return createDefaultConteudosData();
  }
}
export function persistConteudosData(value) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    window.localStorage.setItem(`${STORAGE_KEY}_version`, STORAGE_VERSION);
  } catch {
    // noop
  }
}
export { STORAGE_KEY };
